/* RESPONSIBLE TEAM: team-data-foundations */
import AppstoreAppPackageController from 'embercom/controllers/base/appstore/app-package';

export default AppstoreAppPackageController;
